export const setCoins = (coins) => ({
  type: "SET_COINS",
  payload: coins,
})

export const setPage = (page) => ({
  type: "SET_PAGE",
  payload: page,
})
